import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiChecklist2ReportWidgetBaseDirective } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report-widget-base.directive';
import { IChecklist2ReportAttentionRequired } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { IReportWidget } from '@fi-shared/fi-report-widget/fi-report-widget';

@Component({
    selector: 'fi-deviation-widget',
    templateUrl: './deviation-widget.component.html',
    styleUrls: ['deviation-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-deviation-widget' },
    standalone: false,
})
export class FiDeviationWidgetComponent extends FiChecklist2ReportWidgetBaseDirective implements OnInit {
    protected filteredAttentionRequired: IChecklist2ReportAttentionRequired[];
    protected widgetData: IReportWidget;

    private get deviationsSummary(): IChecklist2ReportAttentionRequired[] {
        return this.reportData.getDeviationsSummary(this.reportParameter.Id);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.setFilteredAttentionRequiredData();
        this.widgetData = {
            description: this.getWidgetDescription(),
            icon: 'far fa-circle-exclamation',
            summaryCount: this.getDeviationsCount(),
        };
    }

    private setFilteredAttentionRequiredData(): void {
        this.filteredAttentionRequired = [...this.deviationsSummary];
    }

    private getDeviationsCount(): number {
        return this.deviationsSummary.reduce((total, item) => total + item.AllAnswers.length, 0);
    }
}
